import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { errorMessage } from '../helpers'

export const FETCH_BALANCE = 'FETCH_BALANCE'
export const FETCH_BALANCE_SUCCESS = 'FETCH_BALANCE_SUCCESS'
export const FETCH_BALANCE_FAILURE = 'FETCH_BALANCE_FAILURE'
export const SAVE_BALANCE_SUCCESS = 'SAVE_BALANCE_SUCCESS'
export const SAVE_BALANCE_FAILURE = 'SAVE_BALANCE_FAILURE'
export const BALANCE_AJAX_CALL = 'BALANCE_AJAX_CALL'
export const BALANCE_CLEAR_AJAX_CALL = 'BALANCE_CLEAR_AJAX_CALL'
export const DELETE_BALANCE_SUCCESS = 'DELETE_BALANCE_SUCCESS'
export const DELETE_BALANCE_FAILURE = 'DELETE_BALANCE_FAILURE'
export const BALANCE_START_UPLOAD = 'BALANCE_START_UPLOAD'
export const BALANCE_STOP_UPLOAD = 'BALANCE_STOP_UPLOAD'

export function loadBalance() {
  return (dispatch) => {
    dispatch(fetchBalance())
    axios({
      method: 'GET',
      url: URIS.balance,
      headers: loadHeaders()
    })
      .then((res) => {
        dispatch(fetchBalanceSuccess(res.data))
      })
      .catch((error) => {
        dispatch(fetchBalanceFailure(errorMessage(error)))
      })
  }
}

function fetchBalance() {
  return {
    type: FETCH_BALANCE
  }
}

function fetchBalanceSuccess(payload) {
  return {
    type: FETCH_BALANCE_SUCCESS,
    payload
  }
}

function fetchBalanceFailure(payload) {
  return {
    type: FETCH_BALANCE_FAILURE,
    payload
  }
}

export function saveBalance(payload) {
  return (dispatch) => {
    dispatch(loadingAjaxCall())
    axios({
      method: 'POST',
      url: URIS.balance,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(saveBalanceSuccess(res.data))
      })
      .catch((error) => {
        dispatch(saveBalanceFailure(errorMessage(error)))
      })
  }
}

function saveBalanceSuccess(payload) {
  return {
    type: SAVE_BALANCE_SUCCESS,
    payload
  }
}

export function saveBalanceFailure(payload) {
  return {
    type: SAVE_BALANCE_FAILURE,
    payload
  }
}

export function deleteBalance(payload) {
  return (dispatch) => {
    dispatch(loadingAjaxCall())
    axios({
      method: 'DELETE',
      url: URIS.balance,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(deleteBalanceSuccess(res.data.data))
      })
      .catch((error) => {
        dispatch(deleteBalanceFailure(errorMessage(error)))
      })
  }
}

function deleteBalanceSuccess(payload) {
  return {
    type: DELETE_BALANCE_SUCCESS,
    payload
  }
}

export function deleteBalanceFailure(payload) {
  return {
    type: DELETE_BALANCE_FAILURE,
    payload
  }
}

function loadingAjaxCall() {
  return {
    type: BALANCE_AJAX_CALL
  }
}

export function clearAjaxCall(payload) {
  return {
    type: BALANCE_CLEAR_AJAX_CALL
  }
}

export function startUpload() {
  return {
    type: BALANCE_START_UPLOAD
  }
}

export function stopUpload() {
  return {
    type: BALANCE_STOP_UPLOAD
  }
}



// WEBPACK FOOTER //
// ./src/actions/Balance.js